import { GetQuoteResponseSchema } from './get-quote.ts';

/**
 * validation schema for the response payload
 * we want to return the whole entity when PATCHing
 */
export const PatchQuoteResponseSchema = GetQuoteResponseSchema;
